import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { AuthItemType } from '@/store/enums/authItemEnum';
import store from '@/store';
import { AUTH_ITEM_ADD } from '@/store/actions/authItem';
import { router } from "@/router";
var AuthItemCreation = /*#__PURE__*/function (_Vue) {
  function AuthItemCreation() {
    var _this;
    _classCallCheck(this, AuthItemCreation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemCreation, [].concat(args));
    _defineProperty(_this, "toggleAuthItemCreationDialog", void 0);
    _defineProperty(_this, "visible", false);
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "authItemCreationForm", {
      name: '',
      type: AuthItemType.SAML2
    });
    _defineProperty(_this, "authTypeOptions", [{
      'label': AuthItemType.SAML2,
      'value': AuthItemType.SAML2
    }]);
    return _this;
  }
  _inherits(AuthItemCreation, _Vue);
  return _createClass(AuthItemCreation, [{
    key: "updateAuthItemName",
    value: function updateAuthItemName(value) {
      this.authItemCreationForm.name = value === null || value === void 0 ? void 0 : value.trim();
    }
  }, {
    key: "updateAuthItemType",
    value: function updateAuthItemType(value) {
      this.authItemCreationForm.type = value;
    }
  }, {
    key: "createAuthentication",
    value: function createAuthentication() {
      var _this2 = this;
      // we load the list of cluster
      this.loading = true;
      store.dispatch(AUTH_ITEM_ADD, {
        name: this.authItemCreationForm.name,
        type: this.authItemCreationForm.type
      }).then(function (resp) {
        var authItem = resp;
        if (authItem.type === AuthItemType.SAML2) {
          router.push({
            name: 'settingsSaml2',
            params: {
              authItemID: authItem.authItemID,
              name: authItem.name
            }
          });
        }
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], AuthItemCreation.prototype, "toggleAuthItemCreationDialog", void 0);
AuthItemCreation = __decorate([Options({
  components: {
    MainTitle: MainTitle
  },
  watch: {
    toggleAuthItemCreationDialog: function toggleAuthItemCreationDialog() {
      this.visible = this.toggleAuthItemCreationDialog;
    }
  }
})], AuthItemCreation);
export default AuthItemCreation;